function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { createRef } from 'react';
import { OverlayTrigger } from 'react-bootstrap';
import { Popover } from 'components/popover/Popover';
import parse from 'html-react-parser';

var PopoverStickOnHover = /*#__PURE__*/function (_React$Component) {
  _inherits(PopoverStickOnHover, _React$Component);

  var _super = _createSuper(PopoverStickOnHover);

  function PopoverStickOnHover(props) {
    var _this;

    _classCallCheck(this, PopoverStickOnHover);

    _this = _super.call(this, props);
    _this.handleMouseEnter = _this.handleMouseEnter.bind(_assertThisInitialized(_this));
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_assertThisInitialized(_this));
    _this.state = {
      showPopover: false,
      isHovered: false
    };
    var refChildren = _this.props.refChildren;
    _this.refChildren = refChildren || /*#__PURE__*/createRef();
    return _this;
  }

  _createClass(PopoverStickOnHover, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$state = this.state,
          isHovered = _this$state.isHovered,
          showPopover = _this$state.showPopover;
      var text = this.props.text;

      if (isHovered && !showPopover && text) {
        this.show();
      }
    }
  }, {
    key: "handleMouseEnter",
    value: function handleMouseEnter() {
      this.setState({
        isHovered: true
      });
      var text = this.props.text;

      if (!text) {
        return;
      }

      this.show();
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      this.hide();
    }
  }, {
    key: "getContainer",
    value: function getContainer() {
      if (!(this.refChildren.current instanceof HTMLElement)) {
        return null;
      }

      return this.refChildren.current.closest('.modal-content');
    }
  }, {
    key: "show",
    value: function show() {
      this.setState({
        showPopover: true
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      this.setState({
        showPopover: false
      });
      this.setState({
        isHovered: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          text = _this$props.text,
          children = _this$props.children,
          placement = _this$props.placement,
          onExited = _this$props.onExited,
          refChildren = _this$props.refChildren,
          asHtml = _this$props.asHtml,
          popoverProps = _this$props.popoverProps;
      var showPopover = this.state.showPopover;
      var newChildren = /*#__PURE__*/React.cloneElement(children, {
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        ref: refChildren ? null : this.refChildren
      });
      var popover = /*#__PURE__*/React.createElement(Popover, _extends({
        id: "popover",
        text: asHtml ? parse(text) : text,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, popoverProps)); // noinspection RequiredAttributes

      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OverlayTrigger, {
        show: showPopover,
        placement: placement,
        overlay: popover,
        onExited: onExited,
        container: this.getContainer(),
        flip: true
      }, newChildren));
    }
  }]);

  return PopoverStickOnHover;
}(React.Component);

export { PopoverStickOnHover };